import React, { useState, useEffect } from "react";
import InputMask from "react-input-mask";

//components
import Buttom from "../../components/Buttom";
import LayoutSteps from "../Shared/LayoutSteps";
import ButtomAmount from "../../components/ButtomAmount/ButtomAmount";

//css
import "./style.scss";

//config
import config from "./../../utils/const";

const Amount = props => {
  const [hasError, setHasError] = useState(false);
  const [selectedValue, setSelectedValue] = useState();
  const [otherValue, setOtherValue] = useState();
  const [tryNext, setTryNext] = useState(false);
  const [installments, setInstallments] = useState(6);

  const {
      actions,
      state,
      state: { donate }
    } = props,
    maskRemove = "R$";

  useEffect(() => {
    actions.setProgressConfig(true, "60%", "3/5", "40%");
  }, [actions]);

  //State Context
  const HandleAction = e => {
    if (hasError || !selectedValue) {
      e.preventDefault();
      setTryNext(true);
    } else {
      actions.setDonate("amount", selectedValue);
      actions.setDonate("installments", donate.frequency === "once" ? 0 : installments);
    }
  };

  const setOther = e => {
    let val = e.target.value.split(maskRemove).pop();

    setSelectedValue(val);
    setOtherValue(val);
    //Layout
    setHasError(val && val < state.minAmount);
  };

  const HandleChange = e => {
    setInstallments(e.target.value);
  };

  const beforeSetSelectedValue = val => {
    setSelectedValue(val);
    setOtherValue("");
    setHasError(false);
  };

  return (
    <LayoutSteps
      className="wrapper-amount"
      renderButtom={() => {
        return (
          <Buttom
            data-class="btn-donation--default"
            text="continuar"
            to={`${config.url}educacao/${state.donate.profile}`}
            onClick={e => {
              HandleAction(e);
            }}
            {...props}
          />
        );
      }}
    >
      <div className="container">
        <p className={`text--lg ${tryNext ? "text-danger" : ""}`}>Selecione ou digite o valor:</p>
        <div className="options">
          <div className="item">
            <ButtomAmount
              className={selectedValue === 20 ? "selected" : ""}
              amount="20"
              onClick={() => {
                beforeSetSelectedValue(20);
              }}
            />
          </div>
          <div className="item">
            <ButtomAmount
              className={selectedValue === 50 ? "selected" : ""}
              amount="50"
              onClick={() => {
                beforeSetSelectedValue(50);
              }}
            />
          </div>
          <div className="item">
            <ButtomAmount
              className={selectedValue === 70 ? "selected" : ""}
              amount="70"
              onClick={() => {
                beforeSetSelectedValue(70);
              }}
            />
          </div>
          <div className="item">
            <ButtomAmount
              className={selectedValue === 100 ? "selected" : ""}
              amount="100"
              onClick={() => {
                beforeSetSelectedValue(100);
              }}
            />
          </div>
          <div className="item">
            <ButtomAmount
              className={selectedValue === 200 ? "selected" : ""}
              amount="200"
              onClick={() => {
                beforeSetSelectedValue(200);
              }}
            />
          </div>
          <div className="item">
            <InputMask type="text" id="txtAmount" name="txtAmount" className="form-control" placeholder="Digite o valor" onChange={e => setOther(e)} value={otherValue} mask="R$9999" maskChar="" />
          </div>
        </div>
        {hasError && <div className="msg text-danger">Valor mínimo R$20,00</div>}
        {props.match.params.monthly === "1" && selectedValue && selectedValue >= state.minAmount && (
          <div className="monthly">
            <div className="monthly__value text-right">{`R$ ${selectedValue} x`}</div>
            <select value={installments} className="monthly__period form-control" onChange={HandleChange}>
              <option value="6">6 meses</option>
              <option value="12">1 ano</option>
              <option value="24">2 anos</option>
              <option value="36">3 anos</option>
            </select>
            <div className="monthly__total text-left">{`= R$ ${selectedValue * installments}`}</div>
          </div>
        )}
      </div>
    </LayoutSteps>
  );
};

export default Amount;
